import { API_URL, SOCKET_URL } from "~/environments/url";

const STEEL_OPERATIONAL_API = "steeloperationaldata/api";

export const API_URL_SUPPORT = `${API_URL}/support/api/support`;

export const API_URL_COPILOT = `${API_URL}/${STEEL_OPERATIONAL_API}/copilot`;

export const GRAPHQL_URL_STEEL_OPERATIONAL = `${API_URL}/${STEEL_OPERATIONAL_API}`;

export const GRAPHQL_AUTHENTICATION = `${API_URL}/user/api`;

export const API_URL_MEDIA = `${API_URL}/media`;

export const STEEL_SOCKET_URL = `${SOCKET_URL}/steel`;
